import { Application } from "@hotwired/stimulus"
import "htmx.org"

// ui
import Theme from "./components/Theme"
import LandingHeader from "./components/landing/LandingHeader.js"
import LandingModules from "./components/landing/LandingModules.js"

const app = Application.start()
app.register("theme", Theme)
app.register("landing-header", LandingHeader)
app.register("landing-modules", LandingModules)
